import React from "react";
import PropTypes from "prop-types";
import { SocialCard } from "../components/social";
import { registerWidget } from "../components/contentful-views/sections";

/**
 * Maps to the Social Card content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/socialCard/fields
 * @param {Object} props
 * @param {Object} props.fields
 */
const SocialCardWidget = ({
  model: {
    fields = {},
  } = {},
}) => {
  const authorPhotoUrl = fields?.authorPhoto?.fields?.file?.url;
  const photoUrl = fields?.photo?.fields?.file?.url;
  const { authorHandle, authorName, url } = fields;
  return (
    <SocialCard
      authorHandle={authorHandle}
      authorName={authorName}
      url={url}
      photoUrl={photoUrl}
      authorPhotoUrl={authorPhotoUrl}
    />
  );
};

SocialCardWidget.propTypes = {
  model: PropTypes.shape({
    fields: PropTypes.shape({
      authorPhoto: PropTypes.shape({
        fields: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string
          })
        })
      }),
      photo: PropTypes.shape({
        fields: PropTypes.shape({
          file: PropTypes.shape({
            url: PropTypes.string
          })
        })
      })
    }),
  }),
};

SocialCardWidget.defaultProps = {
  model: {
    fields: {},
  },
};

registerWidget("socialCard", SocialCardWidget);

export default SocialCardWidget;
